/** API case-request category: Civil Division - Litigation */
export const CIVIL_LITIGATION_CATEGORY_ID = '00e82e42-3f77-4701-862f-783a76dcf120';
export const CIVIL_LITIGATION_CATEGORY_CODE = 'CIVIL_LITIGATION';
export const FILE_CATEGORY_CIVIL_LITIGATION = 'Civil Division - Litigation';

export const CIVIL_LITIGATION_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Party Details' },
  { n: 3, lbl: 'Incident Details' },
  { n: 4, lbl: 'Submission & Physical File Delivery' },
  { n: 5, lbl: 'Upload Documents' },
] as const;

export type CivilLitigationWizardStep = (typeof CIVIL_LITIGATION_WIZARD_STEPS)[number]['n'];

export const CIVIL_LITIGATION_PARTY_BODY_TYPE_LABELS = {
  government: 'Government Ministry/ Department/Other Unincorporated Body',
  incorporated: 'Public Corporation/Statutory Board/State Owned Entity/Other Incorporated Body',
} as const;

/** CMS Data Capture — court types when action is instituted */
export const CIVIL_LITIGATION_COURT_TYPES = [
  { id: 'PHC', name: 'Provincial High Court (PHC)', code: 'PHC' },
  { id: 'HC', name: 'High Court (HC)', code: 'HC' },
  { id: 'DC', name: 'District Court (DC)', code: 'DC' },
  { id: 'CHC', name: 'Commercial High Court (CHC)', code: 'CHC' },
  { id: 'LT', name: 'Labour Tribunal (LT)', code: 'LT' },
  { id: 'MC', name: "Magistrates' Court (MC)", code: 'MC' },
  { id: 'SCC', name: 'Small Claims Court (SCC)', code: 'SCC' },
  { id: 'ARB', name: 'Arbitration (ARB)', code: 'ARB' },
  { id: 'DAB', name: 'Dispute Adjudication Board (DAB)', code: 'DAB' },
  { id: 'USAB', name: 'University Services Appeals Board (USAB)', code: 'USAB' },
  { id: 'AAT', name: 'Administrative Appeals Tribunal (AAT)', code: 'AAT' },
  { id: 'OT', name: 'Other (OT)', code: 'OT' },
] as const;

export function isOtherCourtType(codeOrId: string, name?: string): boolean {
  const c = codeOrId.trim().toUpperCase();
  if (c === 'OT' || c === 'OTHER') return true;
  return (name ?? '').trim().toLowerCase() === 'other';
}
